import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useState } from "react";
import { checkGroupsInStorage, getGroupsFromStorage, setGroupsInStorage } from "../../../utilities/StorageUtils";
import { groupAccess, loginRequest } from "../../../utilities/authConfig";
import { AuthenticationResult } from "@azure/msal-browser";

interface IdTokenClaims {
  groups?: string[];
}

type NavButtonCollectionMobileProps = {
  onNavigate: () => void;
};

const NavButtonCollectionMobile: React.FC<NavButtonCollectionMobileProps> = ({ onNavigate }) => {
  const { instance, accounts } = useMsal();
  const [userGroups, setUserGroups] = useState<string[]>([]);

  useEffect(() => {
    if (accounts.length > 0) {
      const activeAccount = instance.getActiveAccount() || instance.getAllAccounts()[0];

      if (checkGroupsInStorage(activeAccount)) {
        const claimedGroups = getGroupsFromStorage(activeAccount);
        if (claimedGroups) {
          setUserGroups(claimedGroups);
          return;
        }
      }

      const request = {
        ...loginRequest,
        account: activeAccount,
      };

      instance.acquireTokenSilent(request).then((response: AuthenticationResult) => {
        const idTokenClaims = response.idTokenClaims as IdTokenClaims;
        if (idTokenClaims.groups) {
          setUserGroups(idTokenClaims.groups);
          setGroupsInStorage(request.account, idTokenClaims.groups);
        }
      }).catch((error: any) => {
        if (error instanceof InteractionRequiredAuthError) {
          instance.acquireTokenRedirect(request);
        } else {
          console.error(error);
        }
      });
    }
  }, [instance, accounts]);

  const hasGroup = (requiredGroups: string[]): boolean =>
    requiredGroups.some((group) => userGroups.includes(group));

  return (
    <Nav className="nav-container d-flex flex-column justify-content-start align-items-center mb-4 ps-3 pe-3 fs-5">  
      {hasGroup([groupAccess.admin, groupAccess.arbetsledning]) && (
        <NavLink to="/createproject" onClick={onNavigate} className="nav-link mb-3">
          Skapa projekt
        </NavLink>
      )}
      {hasGroup([groupAccess.admin, groupAccess.arbetsledning, groupAccess.worker]) && (
        <NavLink to="/projects" onClick={onNavigate} className="nav-link mb-3">
          Alla Projekt
        </NavLink>
      )}
      {hasGroup([groupAccess.admin, groupAccess.arbetsledning, groupAccess.worker]) && (
        <NavLink to="/myprojects" onClick={onNavigate} className="nav-link mb-3">
          Mina Projekt
        </NavLink>
      )}
      <hr className="w-100" />
      <span className="header-text mb-3">
        {instance.getActiveAccount()?.name}
      </span>
      <Nav.Link href="#" onClick={() => instance.logoutPopup()} className="nav-link">
        Logga ut
      </Nav.Link>
    </Nav>
  );
};

export default NavButtonCollectionMobile;
